<template>
  <div>
    <div class="jumbotron pt-0">
      <p>
        Email domains you have added are listed below. Click on one to see the DNS records that need to be set to make
        it work. You can have multiple email domains set up but only a single one can be used at a time.
      </p>
      <div class="well">
        <add-email-domain-button :profile-locked="profileLocked" :profile-approved="profileApproved"></add-email-domain-button>
      </div>
    </div>

    <div v-if="!domains" class="d-flex justify-content-center">
      <div class="table-loading-indicator"></div>
    </div>

    <email-domains-table
      v-if="domains"
      :domains="domains"
      :timezone="timezone"
      :profile-locked="profileLocked"
      :profile-approved="profileApproved"
      @refresh-domain="onRefreshDomain($event)"
      @refresh-domains="onRefreshDomains"
      @show-dns="onShowDns($event)"
    ></email-domains-table>
    <email-domain-dns-modal
      :domain="dnsDomain"
      :default-subdomain="defaultSubdomain"
      @close-modal="onCloseDnsModal"
    ></email-domain-dns-modal>
  </div>
</template>

<script>
import swal from 'sweetalert2';
import {getUserTimeZone} from '../utility/api/config/getUserTimeZone';
import {getAllEmailDomains} from '../utility/api/vessel/getAllEmailDomains';
import {getVessel} from '../utility/api/vessel/getVessel';
import AddEmailDomainButton from '../components/account/mailer/AddEmailDomainButton';
import EmailDomainsTable from '../components/account/mailer/EmailDomainsTable';
import EmailDomainDnsModal from '../components/account/mailer/EmailDomainDnsModal';

export default {
  name: 'account-email-domain-page',
  components: {AddEmailDomainButton, EmailDomainsTable, EmailDomainDnsModal},
  props: {
    defaultSubdomain: {
      type: String,
      required: true,
    },
    profileLocked: {
      type: Boolean,
      required: true,
      default: false,
    },
    profileApproved: {
      type: Boolean,
      required: true,
      default: false,
    },
  },
  data() {
    return {
      dnsDomain: null,
      domains: null,
      timezone: '',
    };
  },
  methods: {
    async loadEmailDomains() {
      try {
        this.domains = await getAllEmailDomains();
      } catch (error) {
        this.showErrorMessage('Failed to load email domains!');
        this.domains = [];
      }
    },
    onRefreshDomain(domain) {
      if (domain && domain.id) {
        const index = this.domains.findIndex(d => d.id === domain.id);
        const domains = [...this.domains];
        domains.splice(index, 1, domain);
        this.domains = domains;
      }
    },
    onRefreshDomains() {
      this.loadEmailDomains();
    },
    onShowDns(domain) {
      this.dnsDomain = domain;
    },
    onCloseDnsModal() {
      this.dnsDomain = null;

      if (this.getDomainIdFromUrl()) {
        const {origin, pathname} = window.location;
        window.history.replaceState(null, '', origin + pathname);
      }
    },
    getDomainIdFromUrl() {
      const [name, value] = window.location.search.split('&')[0].slice(1).split('=');
      return name === 'domain' ? Number(value) : null;
    },
    showErrorMessage(title) {
      swal.fire({
        title,
        text: `Try again later or contact our support if the problem persists.`,
        type: 'error',
        confirmButtonText: 'Ok',
        buttonsStyling: false,
        confirmButtonClass: 'btn btn-lg btn-primary',
      });
    },
  },
  mounted() {
    const domainId = this.getDomainIdFromUrl();
    this.loadEmailDomains().then(() => (this.dnsDomain = (this.domains || []).find(domain => domain.id === domainId)));
    getUserTimeZone().then(timezone => (this.timezone = timezone));
  },
};
</script>

<style lang="scss" scoped>
.table-loading-indicator {
  background: center / 50px no-repeat url('/wp-content/themes/snappy-theme/assets/images/loading2.gif');
  width: 50px;
  height: 50px;
}
</style>
